// AUTO-GENERIERT (gen_i18n.py cockpit). Schluessel = deutscher UI-Text, Wert = { fr, it, en }.
const cockpit2 = {
  "Danke! Wir prüfen Ihre Anfrage und melden uns mit einer Empfehlung.": {
    "fr": "Merci ! Nous examinons votre demande et vous contacterons avec une recommandation.",
    "it": "Grazie! Verificheremo la sua richiesta e la contatteremo con una raccomandazione.",
    "en": "Thank you! We will review your request and get back to you with a recommendation."
  },
  "Anfrage konnte nicht gesendet werden.": {
    "fr": "La demande n'a pas pu être envoyée.",
    "it": "Impossibile inviare la richiesta.",
    "en": "Request could not be sent."
  },
  "Rechnungen & Laufzeit": {
    "fr": "Factures & Durée",
    "it": "Fatture e durata",
    "en": "Invoices & Term"
  },
  "Ihr Abo, Ihre Rechnungen und Ihre Laufzeit.": {
    "fr": "Votre abonnement, vos factures et votre durée.",
    "it": "Il suo abbonamento, le sue fatture e la durata.",
    "en": "Your subscription, invoices, and contract duration."
  },
  "Aktuelles Paket": {
    "fr": "Forfait actuel",
    "it": "Pacchetto attuale",
    "en": "Current package"
  },
  "/ Monat": {
    "fr": "/ mois",
    "it": "/ mese",
    "en": "/ month"
  },
  "inkl. MWST": {
    "fr": "TVA incl.",
    "it": "IVA inclusa",
    "en": "incl. VAT"
  },
  "Laufzeit bis": {
    "fr": "Durée jusqu'au",
    "it": "Durata fino al",
    "en": "Term until"
  },
  "Monate": {
    "fr": "mois",
    "it": "Mesi",
    "en": "Months"
  },
  "Ihre Rechnungen": {
    "fr": "Vos factures",
    "it": "Le sue fatture",
    "en": "Your invoices"
  },
  "Noch keine Rechnungen.": {
    "fr": "Aucune facture pour le moment.",
    "it": "Nessuna fattura ancora.",
    "en": "No invoices yet."
  },
  "Bezahlt": {
    "fr": "Payé",
    "it": "Pagato",
    "en": "Paid"
  },
  "Überfällig": {
    "fr": "En retard",
    "it": "Scaduto",
    "en": "Overdue"
  },
  "Offen": {
    "fr": "Ouvert",
    "it": "Aperto",
    "en": "Open"
  },
  "A) Im Paket enthalten": {
    "fr": "A) Inclus dans le forfait",
    "it": "A) Incluso nel pacchetto",
    "en": "A) Included in the package"
  },
  "B) Aktive Zusatzmodule": {
    "fr": "B) Modules complémentaires actifs",
    "it": "B) Moduli aggiuntivi attivi",
    "en": "B) Active add-ons"
  },
  "Aktuell keine kostenpflichtigen Zusatzmodule gebucht.": {
    "fr": "Aucun module complémentaire payant actuellement souscrit.",
    "it": "Attualmente nessun modulo aggiuntivo a pagamento attivato.",
    "en": "No paid add-ons currently subscribed."
  },
  "/ Mt.": {
    "fr": "/ mois",
    "it": "/ mese",
    "en": "/ mo."
  },
  "Inklusive": {
    "fr": "Inclus",
    "it": "Incluso",
    "en": "Included"
  },
  "Paket": {
    "fr": "Forfait",
    "it": "Pacchetto",
    "en": "Package"
  },
  "Zusatzmodule": {
    "fr": "Modules complémentaires",
    "it": "Moduli aggiuntivi",
    "en": "Add-ons"
  },
  "Total monatlich": {
    "fr": "Total mensuel",
    "it": "Totale mensile",
    "en": "Total monthly"
  },
  "C) Empfohlene Zusatzleistungen": {
    "fr": "C) Prestations recommandées",
    "it": "C) Servizi aggiuntivi consigliati",
    "en": "C) Recommended additional services"
  },
  "Optional — kann helfen, mehr Anfragen zu erhalten. Auf Wunsch bereiten wir ein Angebot vor.": {
    "fr": "Optionnel — peut aider à recevoir plus de demandes. Sur demande, nous préparons une offre.",
    "it": "Opzionale — può aiutare a ottenere più richieste. Su richiesta prepariamo un'offerta.",
    "en": "Optional — can help you receive more requests. We can prepare an offer upon request."
  },
  "In Ihrem Paket enthalten": {
    "fr": "Inclus dans votre forfait",
    "it": "Incluso nel suo pacchetto",
    "en": "Included in your package"
  },
  "Separates Angebot möglich": {
    "fr": "Offre séparée possible",
    "it": "Offerta separata possibile",
    "en": "Separate offer possible"
  },
  "Mehr erfahren": {
    "fr": "En savoir plus",
    "it": "Ulteriori informazioni",
    "en": "Learn more"
  },
  "Rechnungen anzeigen": {
    "fr": "Afficher les factures",
    "it": "Visualizza fatture",
    "en": "View invoices"
  },
  "Senden…": {
    "fr": "Envoi…",
    "it": "Invio…",
    "en": "Sending…"
  },
  "Upgrade anfragen": {
    "fr": "Demander une mise à niveau",
    "it": "Richiedi upgrade",
    "en": "Request upgrade"
  },
  "Anfragen": {
    "fr": "Demandes",
    "it": "Richieste",
    "en": "Requests"
  },
  "Ihre Anfragen und deren aktueller Stand auf einen Blick.": {
    "fr": "Vos demandes et leur statut en un coup d'œil.",
    "it": "Le sue richieste e il relativo stato attuale in un colpo d'occhio.",
    "en": "Your requests and their current status at a glance."
  },
  "Neu eingegangen": {
    "fr": "Nouveau reçu",
    "it": "Nuove ricevute",
    "en": "Newly received"
  },
  "noch nicht bearbeitet": {
    "fr": "pas encore traité",
    "it": "non ancora elaborate",
    "en": "not yet processed"
  },
  "In Bearbeitung": {
    "fr": "En cours",
    "it": "In lavorazione",
    "en": "In progress"
  },
  "Erledigt": {
    "fr": "Terminé",
    "it": "Completate",
    "en": "Completed"
  },
  "Keine Anfragen in dieser Ansicht.": {
    "fr": "Aucune demande dans cette vue.",
    "it": "Nessuna richiesta in questa vista.",
    "en": "No requests in this view."
  },
  "Interesse gemeldet — wir melden uns bei Ihnen!": {
    "fr": "Intérêt manifesté — nous vous contacterons !",
    "it": "Interesse segnalato — la contatteremo!",
    "en": "Interest expressed — we will contact you!"
  },
  "Konnte nicht senden.": {
    "fr": "Envoi impossible.",
    "it": "Invio non riuscito.",
    "en": "Could not send."
  },
  "Nächste Schritte": {
    "fr": "Prochaines étapes",
    "it": "Prossimi passi",
    "en": "Next steps"
  },
  "Was jetzt ansteht und wie wir Ihren Auftritt weiter ausbauen können.": {
    "fr": "Ce qui est à venir et comment nous pouvons développer davantage votre présence.",
    "it": "Cosa fare ora e come potenziare ulteriormente la sua presenza.",
    "en": "What’s coming up and how we can further develop your presence."
  },
  "Jetzt zu erledigen": {
    "fr": "À faire maintenant",
    "it": "Da fare ora",
    "en": "To do now"
  },
  "Alles erledigt.": {
    "fr": "Tout est fait.",
    "it": "Tutto completato.",
    "en": "All done."
  },
  "Empfohlen für mehr Anfragen": {
    "fr": "Recommandé pour plus de demandes",
    "it": "Raccomandato per più richieste",
    "en": "Recommended for more requests"
  },
  "Optionale Leistungen, die Ihnen helfen können, mehr Anfragen und Kunden zu gewinnen. Unverbindlich — auf Wunsch bereiten wir ein Angebot vor.": {
    "fr": "Prestations optionnelles pouvant vous aider à obtenir plus de demandes et clients. Sans engagement — sur demande, nous préparons une offre.",
    "it": "Servizi opzionali che possono aiutarla a ottenere più richieste e clienti. Senza impegno — su richiesta prepariamo un'offerta.",
    "en": "Optional services that can help you gain more requests and customers. No obligation — we can prepare an offer upon request."
  },
  "Aktuell keine Empfehlungen — Ihr Auftritt ist auf dem neuesten Stand.": {
    "fr": "Aucune recommandation actuellement — votre présence est à jour.",
    "it": "Nessuna raccomandazione attuale — la sua presenza è aggiornata.",
    "en": "No recommendations at the moment — your presence is up to date."
  },
  "Interesse melden": {
    "fr": "Manifester son intérêt",
    "it": "Segnala interesse",
    "en": "Express interest"
  },
  "Frage stellen": {
    "fr": "Poser une question",
    "it": "Fai una domanda",
    "en": "Ask a question"
  },
  "Haben Sie eine eigene Idee?": {
    "fr": "Vous avez une idée ?",
    "it": "Ha un'idea propria?",
    "en": "Do you have your own idea?"
  },
  "Schreiben Sie uns — wir beraten Sie gerne.": {
    "fr": "Écrivez-nous — nous sommes à votre écoute.",
    "it": "Scrivici — saremo lieti di consigliarla.",
    "en": "Write to us — we’re happy to advise you."
  },
  "Direkt": {
    "fr": "Direct",
    "it": "Diretto",
    "en": "Direct"
  },
  "Social Media": {
    "fr": "Réseaux sociaux",
    "it": "Social Media",
    "en": "Social Media"
  },
  "Besuche & Performance": {
    "fr": "Visites & Performance",
    "it": "Visite e performance",
    "en": "Visits & Performance"
  },
  "So entwickelt sich Ihre Website — und was die Zahlen bedeuten.": {
    "fr": "Voici l'évolution de votre site — et ce que signifient les chiffres.",
    "it": "Come si sviluppa il suo sito web — e cosa significano i dati.",
    "en": "How your website is developing — and what the numbers mean."
  },
  "Live-Daten": {
    "fr": "Données en direct",
    "it": "Dati in tempo reale",
    "en": "Live data"
  },
  "Demo-Daten": {
    "fr": "Données démo",
    "it": "Dati di esempio",
    "en": "Demo data"
  },
  "Diese Zahlen stammen live von Ihrer Website (KEWAGPage Analytics Light, datenschutzfreundlich — keine IP-Speicherung, keine Profile).": {
    "fr": "Ces chiffres proviennent en direct de votre site (KEWAGPage Analytics Light, respectueux de la vie privée — pas de stockage d'IP, pas de profils).",
    "it": "Questi dati sono dal vivo dal suo sito (KEWAGPage Analytics Light, rispettoso della privacy — nessuna memorizzazione IP, nessun profilo).",
    "en": "These numbers come live from your website (KEWAGPage Analytics Light, privacy-friendly — no IP storage, no profiling)."
  },
  "Hinweis: Diese Zahlen sind Beispielwerte zur Veranschaulichung. Sobald die Echt-Analyse Ihrer Website angebunden ist, sehen Sie hier Ihre tatsächlichen Besucherdaten.": {
    "fr": "Note : Ces chiffres sont des exemples à titre d'illustration. Une fois l'analyse réelle connectée, vous verrez vos données de visiteurs réelles ici.",
    "it": "Nota: questi dati sono valori esemplificativi. Quando l'analisi reale del suo sito sarà attiva, qui vedrà i dati reali delle visite.",
    "en": "Note: These numbers are sample values for illustration. Once your website’s real analytics are connected, you’ll see your actual visitor data here."
  },
  "Besuche": {
    "fr": "Visites",
    "it": "Visite",
    "en": "Visits"
  },
  "vs. Vormonat": {
    "fr": "vs. mois précédent",
    "it": "rispetto al mese precedente",
    "en": "vs. previous month"
  },
  "Telefon-Klicks": {
    "fr": "Clics téléphoniques",
    "it": "Clic telefonici",
    "en": "Phone Clicks"
  },
  "Besuche der letzten 30 Tage": {
    "fr": "Visites des 30 derniers jours",
    "it": "Visite ultimi 30 giorni",
    "en": "Visits in the Last 30 Days"
  },
  "Jede Säule steht für einen Tag. Mehr Besuche bedeuten mehr potenzielle Kundenkontakte.": {
    "fr": "Chaque colonne représente un jour. Plus de visites signifient plus de contacts clients potentiels.",
    "it": "Ogni colonna rappresenta un giorno. Più visite significano più potenziali contatti clienti.",
    "en": "Each column represents one day. More visits mean more potential customer contacts."
  },
  "«Google» = über die Google-Suche gefunden · «Direkt» = Adresse direkt eingegeben · «Social Media» = über soziale Netzwerke.": {
    "fr": "«Google» = trouvé via la recherche Google · «Direct» = adresse saisie directement · «Social Media» = via les réseaux sociaux.",
    "it": "„Google“ = trovato tramite ricerca Google · „Diretto“ = indirizzo inserito direttamente · „Social Media“ = tramite social network.",
    "en": "“Google” = found via Google search · “Direct” = direct address entry · “Social Media” = via social networks."
  },
  "Top-Seiten": {
    "fr": "Pages principales",
    "it": "Pagine principali",
    "en": "Top Pages"
  },
  "Ergebnisse": {
    "fr": "Résultats",
    "it": "Risultati",
    "en": "Results"
  },
  "Klicks auf Telefonnummer": {
    "fr": "Clics sur le numéro de téléphone",
    "it": "Clic sul numero di telefono",
    "en": "Clicks on Phone Number"
  },
  "Kontaktformular-Nachrichten": {
    "fr": "Messages via formulaire de contact",
    "it": "Messaggi modulo contatto",
    "en": "Contact Form Messages"
  },
  "Unsere Empfehlung": {
    "fr": "Notre recommandation",
    "it": "La nostra raccomandazione",
    "en": "Our Recommendation"
  },
  "PDF konnte nicht geladen werden.": {
    "fr": "Le PDF n'a pas pu être chargé.",
    "it": "Il PDF non può essere caricato.",
    "en": "PDF could not be loaded."
  },
  "Monatsreport": {
    "fr": "Rapport mensuel",
    "it": "Report mensile",
    "en": "Monthly Report"
  },
  "Ihre monatliche Auswertung — sobald verfügbar erscheint sie hier.": {
    "fr": "Votre analyse mensuelle — une fois disponible, elle apparaîtra ici.",
    "it": "La tua analisi mensile — sarà disponibile qui non appena pronta.",
    "en": "Your monthly analysis — will appear here as soon as available."
  },
  "Noch kein Monatsreport veröffentlicht.": {
    "fr": "Aucun rapport mensuel publié pour l’instant.",
    "it": "Nessun report mensile pubblicato ancora.",
    "en": "No monthly report published yet."
  },
  "Neue Anfragen": {
    "fr": "Nouvelles demandes",
    "it": "Nuove richieste",
    "en": "New Inquiries"
  },
  "Aufgaben erledigt": {
    "fr": "Tâches accomplies",
    "it": "Compiti completati",
    "en": "Completed Tasks"
  },
  "Verfügbarkeit": {
    "fr": "Disponibilité",
    "it": "Disponibilità",
    "en": "Availability"
  },
  "neue Anfragen": {
    "fr": "nouvelles demandes",
    "it": "nuove richieste",
    "en": "new inquiries"
  },
  "Website-Besuche": {
    "fr": "Visites du site web",
    "it": "Visite al sito web",
    "en": "Website Visits"
  },
  "Ihre monatliche Auswertung auf einen Blick.": {
    "fr": "Votre analyse mensuelle en un coup d'œil.",
    "it": "La tua analisi mensile a colpo d'occhio.",
    "en": "Your monthly analysis at a glance."
  },
  "Als PDF": {
    "fr": "En PDF",
    "it": "In PDF",
    "en": "As PDF"
  },
  "Zusammenfassung": {
    "fr": "Résumé",
    "it": "Riepilogo",
    "en": "Summary"
  },
  "Beliebteste Seiten": {
    "fr": "Pages les plus populaires",
    "it": "Pagine più popolari",
    "en": "Most Popular Pages"
  },
  "Offene Punkte": {
    "fr": "Points ouverts",
    "it": "Punti aperti",
    "en": "Open Items"
  },
  "Konto & Sicherheit": {
    "fr": "Compte & Sécurité",
    "it": "Account e sicurezza",
    "en": "Account & Security"
  },
  "Schützen Sie Ihren Zugang zum Kunden-Cockpit.": {
    "fr": "Protégez votre accès au Cockpit client.",
    "it": "Proteggi l’accesso al Cockpit cliente.",
    "en": "Protect your access to the customer cockpit."
  },
  "Support": {
    "fr": "Support",
    "it": "Supporto",
    "en": "Support"
  },
  "Ihre Supportfälle bei KEWAG — alles an einem Ort.": {
    "fr": "Vos cas de support KEWAG — tout au même endroit.",
    "it": "I tuoi casi di supporto KEWAG — tutto in un unico posto.",
    "en": "Your support cases at KEWAG — all in one place."
  },
  "Neu": {
    "fr": "Nouveau",
    "it": "Nuovo",
    "en": "New"
  },
  "offene Fälle": {
    "fr": "cas ouverts",
    "it": "casi aperti",
    "en": "open cases"
  },
  "in Bearbeitung": {
    "fr": "en cours",
    "it": "in lavorazione",
    "en": "in progress"
  },
  "Ihre Aktion": {
    "fr": "Votre action",
    "it": "La tua azione",
    "en": "Your Action"
  },
  "warten auf Sie": {
    "fr": "en attente de vous",
    "it": "in attesa di te",
    "en": "awaiting your response"
  },
  "Keine Supportfälle in dieser Ansicht.": {
    "fr": "Aucun cas de support dans cette vue.",
    "it": "Nessun caso di supporto in questa vista.",
    "en": "No support cases in this view."
  },
  "KEWAG wartet auf Ihre Rückmeldung": {
    "fr": "KEWAG attend votre retour",
    "it": "KEWAG attende il tuo riscontro",
    "en": "KEWAG is awaiting your feedback"
  },
  "Lösung vorgeschlagen — bitte bestätigen": {
    "fr": "Solution proposée — veuillez confirmer",
    "it": "Soluzione proposta — si prega di confermare",
    "en": "Solution proposed — please confirm"
  },
  "Nachricht gesendet": {
    "fr": "Message envoyé",
    "it": "Messaggio inviato",
    "en": "Message sent"
  },
  "Vielen Dank — Supportfall bestätigt!": {
    "fr": "Merci — cas de support confirmé !",
    "it": "Grazie — caso di supporto confermato!",
    "en": "Thank you — support case confirmed!"
  },
  "Konnte nicht bestätigen.": {
    "fr": "Confirmation impossible.",
    "it": "Impossibile confermare.",
    "en": "Could not confirm."
  },
  "Zurück zur Übersicht": {
    "fr": "Retour à l’aperçu",
    "it": "Torna alla panoramica",
    "en": "Back to Overview"
  },
  "Ticket": {
    "fr": "Ticket",
    "it": "Ticket",
    "en": "Ticket"
  },
  "KEWAG wartet auf Ihre Rückmeldung. Bitte antworten Sie unten.": {
    "fr": "KEWAG attend votre retour. Veuillez répondre ci-dessous.",
    "it": "KEWAG attende il tuo riscontro. Rispondi qui sotto.",
    "en": "KEWAG is awaiting your feedback. Please reply below."
  },
  "Anhang öffnen": {
    "fr": "Ouvrir la pièce jointe",
    "it": "Apri allegato",
    "en": "Open Attachment"
  },
  "Ihre Nachricht an KEWAG...": {
    "fr": "Votre message à KEWAG...",
    "it": "Il tuo messaggio a KEWAG...",
    "en": "Your message to KEWAG..."
  },
  "Dieser Supportfall ist abgeschlossen.": {
    "fr": "Ce cas de support est clos.",
    "it": "Questo caso di supporto è chiuso.",
    "en": "This support case is closed."
  },
  "Lösung bestätigen & Fall schliessen": {
    "fr": "Confirmer la solution & clore le cas",
    "it": "Conferma soluzione & chiudi caso",
    "en": "Confirm solution & close case"
  },
  "Bitte Betreff und Nachricht ausfüllen.": {
    "fr": "Veuillez renseigner l’objet et le message.",
    "it": "Per favore, compila oggetto e messaggio.",
    "en": "Please fill in subject and message."
  },
  "Supportfall gesendet": {
    "fr": "Cas de support envoyé",
    "it": "Caso di supporto inviato",
    "en": "Support case sent"
  },
  "Neuer Supportfall": {
    "fr": "Nouveau cas de support",
    "it": "Nuovo caso di supporto",
    "en": "New Support Case"
  },
  "Thema": {
    "fr": "Sujet",
    "it": "Argomento",
    "en": "Topic"
  },
  "Betreff": {
    "fr": "Objet",
    "it": "Oggetto",
    "en": "Subject"
  },
  "Worum geht es?": {
    "fr": "De quoi s’agit-il ?",
    "it": "Di cosa si tratta?",
    "en": "What is this about?"
  },
  "Ihre Nachricht": {
    "fr": "Votre message",
    "it": "Il tuo messaggio",
    "en": "Your message"
  },
  "Beschreiben Sie Ihr Anliegen...": {
    "fr": "Décrivez votre demande...",
    "it": "Descrivi la tua richiesta...",
    "en": "Describe your concern..."
  },
  "Abbrechen": {
    "fr": "Annuler",
    "it": "Annulla",
    "en": "Cancel"
  },
  "Supportfall senden": {
    "fr": "Envoyer le cas de support",
    "it": "Invia caso di supporto",
    "en": "Send support case"
  },
  "Freigegeben — vielen Dank!": {
    "fr": "Approuvé — merci !",
    "it": "Approvato — grazie mille!",
    "en": "Approved — thank you!"
  },
  "Konnte nicht freigeben.": {
    "fr": "Approbation impossible.",
    "it": "Impossibile approvare.",
    "en": "Could not approve."
  },
  "Rückmeldung gesendet — danke!": {
    "fr": "Retour envoyé — merci !",
    "it": "Riscontro inviato — grazie!",
    "en": "Feedback sent — thank you!"
  },
  "Aufgaben & Freigaben": {
    "fr": "Tâches & Approbations",
    "it": "Compiti e approvazioni",
    "en": "Tasks & Approvals"
  },
  "Was wir gerade für Sie erledigen und was Sie freigeben oder rückmelden sollen.": {
    "fr": "Ce que nous réalisons pour vous et ce que vous devez approuver ou commenter.",
    "it": "Cosa stiamo facendo per te e cosa devi approvare o segnalare.",
    "en": "What we are currently doing for you and what you should approve or respond to."
  },
  "offene Aufgaben": {
    "fr": "tâches ouvertes",
    "it": "compiti aperti",
    "en": "open tasks"
  },
  "alles im Griff": {
    "fr": "tout sous contrôle",
    "it": "tutto sotto controllo",
    "en": "everything under control"
  },
  "Keine Aufgaben in dieser Ansicht.": {
    "fr": "Aucune tâche dans cette vue.",
    "it": "Nessun compito in questa visualizzazione.",
    "en": "No tasks in this view."
  },
  "Das brauchen wir von Ihnen": {
    "fr": "Nous avons besoin de ceci de votre part",
    "it": "Questo è ciò di cui abbiamo bisogno da lei",
    "en": "We need this from you"
  },
  "Ihre Rückmeldung:": {
    "fr": "Votre retour :",
    "it": "Il suo riscontro:",
    "en": "Your feedback:"
  },
  "Jetzt freigeben": {
    "fr": "Libérer maintenant",
    "it": "Rilascia ora",
    "en": "Release now"
  },
  "Rückmeldung geben": {
    "fr": "Donner un retour",
    "it": "Fornire riscontro",
    "en": "Provide feedback"
  },
  "Von Ihnen freigegeben": {
    "fr": "Approuvé par vous",
    "it": "Rilasciato da lei",
    "en": "Released by you"
  },
  "Wir kümmern uns darum": {
    "fr": "Nous nous en chargeons",
    "it": "Ce ne occupiamo noi",
    "en": "We will take care of it"
  },
  "Ihre Rückmeldung an KEWAG...": {
    "fr": "Votre retour à KEWAG...",
    "it": "Il suo riscontro a KEWAG...",
    "en": "Your feedback to KEWAG..."
  },
  "Die Benutzerverwaltung ist nur für den Kunden-Admin verfügbar.": {
    "fr": "La gestion des utilisateurs est réservée à l’administrateur client.",
    "it": "La gestione utenti è disponibile solo per l'amministratore cliente.",
    "en": "User management is only available for customer admins."
  },
  "Team & Benutzer": {
    "fr": "Équipe & utilisateurs",
    "it": "Team & Utenti",
    "en": "Team & Users"
  },
  "Mitarbeiter Ihrer Firma anlegen und Zugriffe steuern.": {
    "fr": "Créer des collaborateurs et gérer les accès.",
    "it": "Crea dipendenti della sua azienda e gestisci gli accessi.",
    "en": "Create your company's employees and manage access."
  },
  "Überblick": {
    "fr": "Vue d’ensemble",
    "it": "Panoramica",
    "en": "Overview"
  },
  "Aufgaben": {
    "fr": "Tâches",
    "it": "Compiti",
    "en": "Tasks"
  },
  "Super-Admin-Ansicht – Sie betreuen diesen Kunden als KEWAG.": {
    "fr": "Vue Super-Admin – vous gérez ce client en tant que KEWAG.",
    "it": "Vista Super-Admin – Lei assiste questo cliente come KEWAG.",
    "en": "Super-admin view – you are managing this customer as KEWAG."
  },
  "Zurück zum Admin": {
    "fr": "Retour à l’admin",
    "it": "Torna all'amministratore",
    "en": "Back to admin"
  },
  "Kunden-Cockpit": {
    "fr": "Cockpit client",
    "it": "Cockpit cliente",
    "en": "Customer cockpit"
  },
  "Abmelden": {
    "fr": "Se déconnecter",
    "it": "Disconnetti",
    "en": "Log out"
  },
  "Admin": {
    "fr": "Admin",
    "it": "Amministratore",
    "en": "Admin"
  },
  "Eine Aufgabe wartet auf Ihre Freigabe.": {
    "fr": "Une tâche attend votre approbation.",
    "it": "Un compito attende la sua approvazione.",
    "en": "A task is waiting for your approval."
  },
  "Neue Anfragen sind eingegangen — wir kümmern uns darum.": {
    "fr": "Nouvelles demandes reçues — nous nous en occupons.",
    "it": "Sono arrivate nuove richieste — ce ne occupiamo noi.",
    "en": "New requests have arrived — we will take care of it."
  },
  "Aktuell ist alles im grünen Bereich.": {
    "fr": "Tout est actuellement en ordre.",
    "it": "Al momento tutto è nella norma.",
    "en": "Everything is currently green."
  },
  "Ihre Website ist online. KEWAG betreut Ihre offenen Punkte und meldet sich, wenn Ihre Freigabe benötigt wird.": {
    "fr": "Votre site web est en ligne. KEWAG gère vos points ouverts et vous contactera si une approbation est nécessaire.",
    "it": "Il suo sito web è online. KEWAG gestisce i suoi punti aperti e la contatterà se serve la sua approvazione.",
    "en": "Your website is online. KEWAG manages your open points and will contact you if your approval is needed."
  },
  "Ihre Website wird gerade betreut. KEWAG kümmert sich und meldet sich bei Ihnen.": {
    "fr": "Votre site est en cours de gestion. KEWAG s’en occupe et vous contactera.",
    "it": "Il suo sito web è in gestione. KEWAG si occupa di tutto e la contatterà.",
    "en": "Your website is being managed. KEWAG is handling it and will contact you."
  },
  "Willkommen": {
    "fr": "Bienvenue",
    "it": "Benvenuto",
    "en": "Welcome"
  },
  "Website-Cockpit": {
    "fr": "Cockpit site web",
    "it": "Website-Cockpit",
    "en": "Website cockpit"
  },
  "Ihre Website, Aufgaben und Betreuung auf einen Blick.": {
    "fr": "Votre site, tâches et gestion en un coup d’œil.",
    "it": "Il suo sito web, compiti e assistenza in un colpo d'occhio.",
    "en": "Your website, tasks and management at a glance."
  },
  "Nächster wichtiger Schritt:": {
    "fr": "Prochaine étape importante :",
    "it": "Prossimo passo importante:",
    "en": "Next important step:"
  },
  "Ihr Paket": {
    "fr": "Votre forfait",
    "it": "Il suo pacchetto",
    "en": "Your package"
  },
  "Mt.": {
    "fr": "Mois",
    "it": "al mese",
    "en": "Mo."
  },
  "Aktive Zusatzmodule": {
    "fr": "Modules complémentaires actifs",
    "it": "Moduli aggiuntivi attivi",
    "en": "Active add-ons"
  },
  "Paket & Leistungen ansehen": {
    "fr": "Voir forfait & services",
    "it": "Visualizza pacchetto e servizi",
    "en": "View package & services"
  },
  "Pocket Admin ist als Spezial-App verbunden.": {
    "fr": "Pocket Admin est relié en tant qu’app spécialisée.",
    "it": "Pocket Admin è collegato come app speciale.",
    "en": "Pocket Admin is connected as a special app."
  },
  "App-Domain": {
    "fr": "Domaine de l’app",
    "it": "Dominio app",
    "en": "App domain"
  },
  "Fundio Pocket Admin öffnen": {
    "fr": "Ouvrir Fundio Pocket Admin",
    "it": "Apri Fundio Pocket Admin",
    "en": "Open Fundio Pocket Admin"
  },
  "App-Domain noch nicht aktiv": {
    "fr": "Domaine de l’app pas encore actif",
    "it": "Dominio app non ancora attivo",
    "en": "App domain not active yet"
  },
  "offene Anfragen": {
    "fr": "demandes ouvertes",
    "it": "richieste aperte",
    "en": "open requests"
  },
  "Offene Aufgaben": {
    "fr": "Tâches ouvertes",
    "it": "Compiti aperti",
    "en": "Open tasks"
  },
  "neue Nachrichten": {
    "fr": "nouveaux messages",
    "it": "nuovi messaggi",
    "en": "new messages"
  },
  "Demo-Daten – nicht verbunden": {
    "fr": "Données démo – non connectées",
    "it": "Dati demo – non connesso",
    "en": "Demo data – not connected"
  },
  "Keine offenen Punkte.": {
    "fr": "Aucun point ouvert.",
    "it": "Nessun punto aperto.",
    "en": "No open points."
  },
  "Letzte Änderungen": {
    "fr": "Dernières modifications",
    "it": "Ultime modifiche",
    "en": "Recent changes"
  },
  "Noch keine Aktivität.": {
    "fr": "Aucune activité pour l’instant.",
    "it": "Ancora nessuna attività.",
    "en": "No activity yet."
  },
  "Nächste Rechnung:": {
    "fr": "Prochaine facture :",
    "it": "Prossima fattura:",
    "en": "Next invoice:"
  },
  "Ihr KEWAG-Betreuungsteam": {
    "fr": "Votre équipe de gestion KEWAG",
    "it": "Il suo team di assistenza KEWAG",
    "en": "Your KEWAG support team"
  },
  "Ihre persönlichen Ansprechpartner bei KEWAG.": {
    "fr": "Vos interlocuteurs personnels chez KEWAG.",
    "it": "I suoi contatti personali presso KEWAG.",
    "en": "Your personal contacts at KEWAG."
  },
  "Ihr KEWAG-Betreuungsteam wird noch zugewiesen. Bei Fragen kontaktieren Sie den KEWAG Support.": {
    "fr": "Votre équipe KEWAG sera attribuée bientôt. Pour toute question, contactez le support KEWAG.",
    "it": "Il suo team di assistenza KEWAG sarà assegnato a breve. Per domande contatti il supporto KEWAG.",
    "en": "Your KEWAG support team will be assigned soon. For questions, contact KEWAG Support."
  },
  "Nachricht senden": {
    "fr": "Envoyer un message",
    "it": "Invia messaggio",
    "en": "Send message"
  },
  "KEWAG Support per E-Mail kontaktieren": {
    "fr": "Contacter le support KEWAG par e-mail",
    "it": "Contattare il supporto KEWAG via e-mail",
    "en": "Contact KEWAG support by e-mail"
  },
  "Nachricht gesendet · Support-Ticket erstellt": {
    "fr": "Message envoyé · ticket support créé",
    "it": "Messaggio inviato · Ticket di supporto creato",
    "en": "Message sent · Support ticket created"
  },
  "Senden fehlgeschlagen. Bitte nutzen Sie den E-Mail-Link.": {
    "fr": "Envoi échoué. Merci d’utiliser le lien e-mail.",
    "it": "Invio fallito. Per favore usi il link e-mail.",
    "en": "Sending failed. Please use the email link."
  },
  "Nachricht an KEWAG senden": {
    "fr": "Envoyer un message à KEWAG",
    "it": "Invia messaggio a KEWAG",
    "en": "Send message to KEWAG"
  },
  "Ihre Nachricht wird als Support-Ticket an Ihr KEWAG-Team übermittelt.": {
    "fr": "Votre message sera transmis à votre équipe KEWAG sous forme de ticket support.",
    "it": "Il suo messaggio sarà trasmesso come ticket di supporto al suo team KEWAG.",
    "en": "Your message will be forwarded as a support ticket to your KEWAG team."
  },
  "Kategorie": {
    "fr": "Catégorie",
    "it": "Categoria",
    "en": "Category"
  },
  "Nachricht": {
    "fr": "Message",
    "it": "Messaggio",
    "en": "Message"
  },
  "Senden": {
    "fr": "Envoyer",
    "it": "Invia",
    "en": "Send"
  },
  "KEWAG prüft diese Verbindung.": {
    "fr": "KEWAG vérifie cette connexion.",
    "it": "KEWAG sta verificando questa connessione.",
    "en": "KEWAG is verifying this connection."
  },
  "Keine Website hinterlegt": {
    "fr": "Aucun site web enregistré",
    "it": "Nessun sito web registrato",
    "en": "No website registered"
  },
  "Einrichtung erforderlich": {
    "fr": "Configuration requise",
    "it": "Configurazione necessaria",
    "en": "Setup required"
  },
  "Website nicht erreichbar": {
    "fr": "Site web inaccessible",
    "it": "Sito web non raggiungibile",
    "en": "Website not reachable"
  },
  "Bitte prüfen": {
    "fr": "Veuillez vérifier",
    "it": "Per favore verifica",
    "en": "Please check"
  },
  "Website online & WordPress verbunden": {
    "fr": "Site web en ligne & WordPress connecté",
    "it": "Sito web online e WordPress connesso",
    "en": "Website online & WordPress connected"
  },
  "Live geprüft": {
    "fr": "Vérifié en direct",
    "it": "Controllato dal vivo",
    "en": "Live checked"
  },
  "Website online": {
    "fr": "Site web en ligne",
    "it": "Sito web online",
    "en": "Website online"
  },
  "Website in Vorbereitung": {
    "fr": "Site web en préparation",
    "it": "Sito web in preparazione",
    "en": "Website in preparation"
  },
  "In Einrichtung": {
    "fr": "En configuration",
    "it": "In configurazione",
    "en": "Setting up"
  },
  "Bitte WordPress-Website hinterlegen.": {
    "fr": "Veuillez indiquer le site WordPress.",
    "it": "Per favore inserisci il sito WordPress.",
    "en": "Please provide WordPress website."
  },
  "Keine WordPress-Website hinterlegt. Bitte über KEWAG verbinden lassen.": {
    "fr": "Aucun site WordPress indiqué. Veuillez connecter via KEWAG.",
    "it": "Nessun sito WordPress inserito. Per favore collegalo tramite KEWAG.",
    "en": "No WordPress website provided. Please connect via KEWAG."
  },
  "Website": {
    "fr": "Site web",
    "it": "Sito web",
    "en": "Website"
  },
  "Online": {
    "fr": "En ligne",
    "it": "Online",
    "en": "Online"
  },
  "Formulare": {
    "fr": "Formulaires",
    "it": "Moduli",
    "en": "Forms"
  },
  "Verbunden": {
    "fr": "Connecté",
    "it": "Connesso",
    "en": "Connected"
  },
  "Besuchertracking": {
    "fr": "Suivi des visiteurs",
    "it": "Tracciamento visitatori",
    "en": "Visitor tracking"
  },
  "Aktiv": {
    "fr": "Actif",
    "it": "Attivo",
    "en": "Active"
  },
  "Backup": {
    "fr": "Sauvegarde",
    "it": "Backup",
    "en": "Backup"
  },
  "Geschützt": {
    "fr": "Protégé",
    "it": "Protetto",
    "en": "Protected"
  },
  "Betreuung": {
    "fr": "Support",
    "it": "Assistenza",
    "en": "Support"
  },
  "KEWAG betreut Ihre Website": {
    "fr": "KEWAG gère votre site web",
    "it": "KEWAG gestisce il tuo sito web",
    "en": "KEWAG supports your website"
  },
  "Zuletzt live geprüft:": {
    "fr": "Dernière vérification en direct :",
    "it": "Ultimo controllo dal vivo:",
    "en": "Last live check:"
  },
  "Website besuchen": {
    "fr": "Visiter le site",
    "it": "Visita sito",
    "en": "Visit website"
  },
  "Entwurf": {
    "fr": "Brouillon",
    "it": "Bozza",
    "en": "Draft"
  },
  "Storniert": {
    "fr": "Annulé",
    "it": "Annullato",
    "en": "Canceled"
  },
  "Warten auf Kunde": {
    "fr": "En attente client",
    "it": "In attesa cliente",
    "en": "Waiting for customer"
  },
  "Warten auf KEWAG": {
    "fr": "En attente KEWAG",
    "it": "In attesa KEWAG",
    "en": "Waiting for KEWAG"
  },
  "Lösung vorgeschlagen": {
    "fr": "Solution proposée",
    "it": "Soluzione proposta",
    "en": "Solution proposed"
  },
  "Archiviert": {
    "fr": "Archivé",
    "it": "Archiviato",
    "en": "Archived"
  },
  "Kritisch": {
    "fr": "Critique",
    "it": "Critico",
    "en": "Critical"
  },
  "Hoch": {
    "fr": "Élevé",
    "it": "Alto",
    "en": "High"
  },
  "Mittel": {
    "fr": "Moyen",
    "it": "Medio",
    "en": "Medium"
  },
  "Niedrig": {
    "fr": "Faible",
    "it": "Basso",
    "en": "Low"
  },
  "In Arbeit": {
    "fr": "En cours",
    "it": "In lavorazione",
    "en": "In progress"
  },
  "Prüfung / Freigabe": {
    "fr": "Vérification / Approbation",
    "it": "Controllo / Approvazione",
    "en": "Review / approval"
  },
  "In Aufbau": {
    "fr": "En construction",
    "it": "In costruzione",
    "en": "Under construction"
  },
  "Wartung": {
    "fr": "Maintenance",
    "it": "Manutenzione",
    "en": "Maintenance"
  },
  "Pausiert": {
    "fr": "Suspendu",
    "it": "Pausato",
    "en": "Paused"
  }
};

export default cockpit2;
